/* eslint-disable @typescript-eslint/no-explicit-any */
export class Base64Util {

    public static serialize(object: unknown | null | undefined): string | null {
        if (!object) { return null; }

        const json = JSON.stringify(object);
        return this.utf8ToBase64(json);
    }

    public static deserialize(object: string | null | undefined): any {
        if (!object) { return {}; }

        const str = this.base64ToUtf8(object);
        return JSON.parse(str);
    }

    private static utf8ToBase64(str: string): string {
        return window.btoa(unescape(encodeURIComponent(str)));
    }

    private static base64ToUtf8(str: string): string {
        return decodeURIComponent(escape(window.atob(str)));
    }

}
